import SnackVariant from '../../components/snackbars/SnackVariant'

export default SnackVariant ;